import { getBatchActiveColor, getBatchActiveTexture } from 'store/batch/selectors';
import useMemoSelector from 'hooks/useMemoSelector';
import { PreviewModalImage, PreviewModalImageBox, PreviewModalZoomWrapper, PreviewModalZoomDesktopActions } from 'pages/Batch/components/PreviewModal/ModalSlices';

import useStyles from './styles';

interface IRemoveBackgroundModalContentProps {
    imageSrc: string;
}
const RemoveBackgroundModalContent = ({ imageSrc }: IRemoveBackgroundModalContentProps) => {
  const { activeColor, activeTexture } = useMemoSelector(state => ({
    activeColor: getBatchActiveColor(state),
    activeTexture: getBatchActiveTexture(state),
  }));

  const classes = useStyles({
    bgColor: activeColor,
    texture: activeTexture?.url,
  });

  return (
    <>
      <PreviewModalImageBox>
        <PreviewModalZoomWrapper>
          <PreviewModalImage imageSrc={imageSrc} className={classes.image} />
        </PreviewModalZoomWrapper>
      </PreviewModalImageBox>
      <PreviewModalZoomDesktopActions />
    </>
  );
};

export default RemoveBackgroundModalContent;
